import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  logo: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

export const SidebarLogo = (props: { to?: string }) => {
  const { to = '/' } = props;
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();
  return to ? (
    <div className={classes.root}>
      <Link to={to} underline="none" className={classes.logo}>
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  ) : (
    <div className={classes.root}>
      <div className={classes.logo}>{isOpen ? <LogoFull /> : <LogoIcon />}</div>
    </div>
  );
};
